/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('EventGroupManagerCtrl', ["$rootScope", '$scope', '$http', 'NetworkService', 'MainService', 'IntentService', function ($rootScope, $scope, $http, NetworkService, MainService, IntentService) {

        $scope.mitarbeiter = []
        $scope.groupsInRead = []
        $scope.groupsInWrite = []
        $scope.groupsInManage = []


        $rootScope.$on("getGroupMembers", function () {

            var data = {read: $scope.groupsInRead,
                write: $scope.groupsInWrite,
                manage: $scope.groupsInManage}
            $rootScope.$emit("getGroupMembersReturn", data)
            MainService.setEventData(data)

        })



        $scope.updateInGroup = function (event, data)
        {
            $scope.groupsInRead = data
        }
        
        $scope.updateAllInGroup = function (event, data)
        {
            $scope.groupsInRead = data.groupsInRead
            $scope.groupsInWrite = data.groupsInWrite
            $scope.groupsInManage = data.groupsInManage
            console.log("ppppppppp")
            console.log(data)
        }

        $rootScope.$on("setGroupMembers", $scope.updateInGroup)
        
        $rootScope.$on("setAllGroupMembers", $scope.updateAllInGroup)

        NetworkService.getGroups(function (data)
        {
            var groups = data.data;
           /* groups.forEach(function (el) {
                if (el.Gruppenname == "standard")
                {
                    $scope.groupsInRead.push(el)
                } else if (el.Gruppenname == "admin")
                {
                    $scope.groupsInManage.push(el)
                }
            })*/
            $scope.groups = groups
        })

        $scope.changeStateInRead = function (Gruppenname)
        {
            $scope.groupsInRead.forEach(function (el) {
                if (el.Gruppenname == Gruppenname)
                {
                    if (el.active == true)
                    {
                        el.active = false;
                    } else
                    {
                        el.active = true
                    }

                }
            })
        }

        $scope.changeStateInWrite = function (Gruppenname)
        {

            $scope.groupsInWrite.forEach(function (el) {
                if (el.Gruppenname == Gruppenname)
                {
                    if (el.active == true)
                    {
                        el.active = false;
                    } else
                    {
                        el.active = true
                    }
                }
            })
        }

        $scope.changeStateInManage = function (Gruppenname)
        {

            $scope.groupsInManage.forEach(function (el) {
                if (el.Gruppenname == Gruppenname)
                {
                    if (el.active == true)
                    {
                        el.active = false;
                    } else
                    {
                        el.active = true
                    }
                }
            })
        }

        $scope.moveToPersons = function ()
        {
            var newMitarbeiterInGroup = []
            $scope.groupsInRead.forEach(function (el) {
                if (el.active)
                {

                } else
                {
                    var newEl = {}
                    newEl.descr = el.descr
                    newEl.name = el.name
                    newEl.Gruppenname = el.Gruppenname
                    newMitarbeiterInGroup.push(newEl)
                }
            })
            $scope.groupsInRead = newMitarbeiterInGroup;
        }

        $scope.changeState = function (Gruppenname)
        {
            $scope.groups.forEach(function (el) {
                if (el.Gruppenname == Gruppenname)
                {
                    el.active = true
                }
            })
        }

        $scope.arrayContained = function (a1, el)
        {
            ret = false
            a1.forEach(function (ela) {
                if (ela.Gruppenname == el.Gruppenname)
                {
                    ret = true
                }
            })

            return ret;
        }
        $scope.moveToRead = function ()
        {
            $scope.groups.forEach(function (el) {
                if (el.active)
                {
                    el.active = false;
                    var newEl = {}
                    newEl.descr = el.descr
                    newEl.name = el.name
                    newEl.Gruppenname = el.Gruppenname
                    if (!$scope.arrayContained($scope.groupsInRead, el))
                    {
                        $scope.groupsInRead.push(newEl)
                    }

                }
            })
        }

        $scope.moveToWrite = function ()
        {
            var newGroupsInRead = []
            $scope.groupsInRead.forEach(function (el) {
                if (el.active)
                {
                    el.active = false;
                    var newEl = {}
                    newEl.descr = el.descr
                    newEl.name = el.name
                    newEl.Gruppenname = el.Gruppenname
                    if (!$scope.arrayContained($scope.groupsInWrite, el))
                    {
                        $scope.groupsInWrite.push(newEl)
                    } else
                    {
                        newGroupsInRead.push(el)
                    }

                } else
                {
                    newGroupsInRead.push(el)
                }
            })
            $scope.groupsInRead = newGroupsInRead

        }

        $scope.moveToManage = function ()
        {
            var newGroupsInWrite = []
            $scope.groupsInWrite.forEach(function (el) {
                if (el.active)
                {
                    el.active = false;
                    var newEl = {}
                    newEl.descr = el.descr
                    newEl.name = el.name
                    newEl.Gruppenname = el.Gruppenname
                    $scope.groupsInManage.push(newEl)
                } else
                {
                    newGroupsInWrite.push(el)
                }
            })
            $scope.groupsInWrite = newGroupsInWrite;
        }

        $scope.moveBackFromManage = function ()
        {
            var newMitarbeiterInGroup = []
            $scope.groupsInManage.forEach(function (el) {
                if (el.active)
                {
                    $scope.groupsInWrite.push(el)
                } else
                {
                    var newEl = {}
                    newEl.descr = el.descr
                    newEl.name = el.name
                    newEl.Gruppenname = el.Gruppenname
                    newMitarbeiterInGroup.push(newEl)
                }
            })
            $scope.groupsInManage = newMitarbeiterInGroup;
        }

        $scope.moveBackFromWrite = function ()
        {
            var newMitarbeiterInGroup = []
            $scope.groupsInWrite.forEach(function (el) {
                if (el.active)
                {
                    $scope.groupsInRead.push(el)
                } else
                {
                    var newEl = {}
                    newEl.descr = el.descr
                    newEl.name = el.name
                    newEl.Gruppenname = el.Gruppenname
                    newMitarbeiterInGroup.push(newEl)
                }
            })
            $scope.groupsInWrite = newMitarbeiterInGroup;
        }

        $scope.moveBackFromRead = function ()
        {
            var newMitarbeiterInGroup = []
            $scope.groupsInRead.forEach(function (el) {
                if (el.active)
                {

                } else
                {
                    var newEl = {}
                    newEl.descr = el.descr
                    newEl.name = el.name
                    newEl.Gruppenname = el.Gruppenname
                    newMitarbeiterInGroup.push(newEl)
                }
            })
            $scope.groupsInRead = newMitarbeiterInGroup;
        }

    }])